var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingBag = function SvgShoppingBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M9.833 4.667a2.333 2.333 0 1 1-4.667 0m-2.547-.35-.408 4.9c-.088 1.053-.132 1.58.046 1.985.156.357.427.652.77.837.39.211.918.211 1.974.211h4.997c1.057 0 1.585 0 1.975-.211a1.75 1.75 0 0 0 .77-.837c.177-.406.133-.932.046-1.985l-.409-4.9c-.075-.905-.113-1.358-.314-1.7a1.75 1.75 0 0 0-.755-.696c-.358-.171-.812-.171-1.721-.171H5.41c-.91 0-1.364 0-1.722.171a1.75 1.75 0 0 0-.755.695c-.2.343-.238.796-.314 1.701"
  })));
};
export default SvgShoppingBag;